export const POI_STATUS = {
  DRAFT: 'draft',
  PUBLISHED: 'published',
  ARCHIVED: 'archived',
  DELETED: 'deleted',
} as const

export type PoiStatus = (typeof POI_STATUS)[keyof typeof POI_STATUS]
